import { fork, put, takeLatest } from 'redux-saga/effects';

import { MANUAL_PAYMENT } from './ManualPaymentModal.actions';
import { OPEN_MODAL } from '../../../iwModals/Modals.actions';

export const manualPaymentModalSagasWorkers = [fork(manualPayment)];

function* manualPayment() {
    yield takeLatest(MANUAL_PAYMENT, function* () {
        yield put({
            type: OPEN_MODAL,
            id: 'ManualPaymentModal'
        });
    });
}
